<template>
  <div>
    <sidebar
      :items="sidebarItems"
      expand-on="click"
      :lock-sidebar-btn="true"
      :title="$store.state.title"
      title-link="/home"
      :show-logo="true"
      logo="vue-crud-avatar.png"
      sidebar-color="white"
      :sidebar-dark="false"
      title-color="white"
      :title-dark="false"
      nav-color="primary"
    >
      <template slot="nav">
        <v-list-item-action>
          <!-- <v-icon color="white">person</v-icon> -->
          <!-- <v-badge
          color="#EF5350"
          content="6"
          overlap
          >
            <v-icon color="white">notifications</v-icon>
          </v-badge> -->
          <!-- <v-icon color="white">notifications</v-icon> -->
          <v-avatar
            color="primary"
          >
            <v-icon color="white">person</v-icon>
          </v-avatar>
        </v-list-item-action>
        <v-list-item-title class="white--text">{{ userInfo.name }}
          <br/>
        <small>{{ userInfo.email }}</small>
        </v-list-item-title> <!-- class="white--text" -->
      </template>
    </sidebar>
    <toolbar
      :notification-btn="notification"
      :profile-btn="profile"
      :locales-btn="false"
      :logout-btn="true"
      color="white"
      :dark="false"
    >
      <template slot="left">
        <div class="d-none d-md-inline">
          <template v-if="$store.state.app.module !=null">
              {{ $t('global.routes.' + $store.state.app.module) }}
          </template>
          <template v-if="$store.state.app.page !=null">
              <!-- <v-icon slot="divider">forward</v-icon> -->
              <v-icon slot="divider">keyboard_arrow_right</v-icon>
              {{ $t('global.routes.' + $store.state.app.page) }}
          </template>
        </div>
      </template>
    </toolbar>

    <v-content class="content">
      <v-container fluid fill-height class="main-container">
        <v-layout style="width:100%">
          <v-flex xs12>
            <v-card flat class="main-card">
              <v-card-text class="content-container">

                <router-view style="margin: 0 auto;"></router-view>

                <alert-box></alert-box>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <footnote
      v-if="footer"
      color="secondary"
      :dark="true"
    >
      <template slot="left">
        <a href="https://vue-crud.github.io/" target="_blank" style="color:white;text-decoration:none;">
          <v-icon color="white">help</v-icon>  tools.omsag.de
        </a>
      </template>
      <template slot="center">
        {{ userInfo.name }}
      </template>
      <template slot="right">
        &#9400; {{ year }}
      </template>
    </footnote>
    <back-top></back-top>
    <profile v-if="profile"></profile>
    <notification v-if="notification"></notification>
  </div>
</template>

<script>
import Sidebar from '@/utils/app/components/Sidebar.vue'
import Toolbar from '@/utils/app/components/Toolbar.vue'
import AlertBox from '@/utils/app/components/AlertBox.vue'
import Footnote from '@/utils/app/components/Footnote.vue'
import BackTop from '@/utils/app/components/BackTop.vue'
import Profile from '@/utils/app/components/Profile.vue'
import Notification from '@/utils/app/components/Notification.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data: () => ({
    profile: true,
    footer: true,
    notification: true,
    sidebarItems: [
      {
        icon: 'person',
        text: 'user.name',
        model: false,
        guard: 'TODO',
        route: '/user',
        children: [
          {
            text: 'user.todos',
            route: '/todos',
          },
        ],
      },
      {
        icon: 'sync_problem',
        text: 'opticheck.name',
        model: false,
        guard: 'OPTICHECK',
        route: '/opticheck',
        children: [
          {
            text: 'opticheck.import',
            route: '/import',
          },
          {
            text: 'opticheck.tasks',
            route: '/tasks',
          },
        ],
      },
      {
        // icon: 'local_atm',
        icon: '$vuetify.icons.adwords',
        text: 'adwords.name',
        model: false,
        guard: 'ADWORDS',
        route: '/adwords',
        children: [
          {
            text: 'adwords.dashboard',
            route: '/dashboard',
          },
        ],
      },
      // {
      //   icon: 'people',
      //   text: 'crm.name',
      //   model: false,
      //   guard: 'CRM',
      //   route: '/crm',
      //   children: [
      //     {
      //       text: 'crm.companies',
      //       route: '/companies',
      //     },
      //     {
      //       text: 'crm.companyTypes',
      //       route: '/company-types',
      //     },
      //     {
      //       text: 'crm.companyFiles',
      //       route: '/company-files',
      //     },
      //     {
      //       text: 'crm.companyComments',
      //       route: '/company-comments',
      //     },
      //     {
      //       text: 'crm.companyCommentTypes',
      //       route: '/company-comment-types',
      //     },
      //     {
      //       text: 'crm.people',
      //       route: '/people',
      //     },
      //     {
      //       text: 'crm.personComments',
      //       route: '/person-comments',
      //     },
      //     {
      //       text: 'crm.personCommentTypes',
      //       route: '/person-comment-types',
      //     },
      //     {
      //       text: 'crm.positions',
      //       route: '/positions',
      //     },
      //     {
      //       text: 'crm.positionTasks',
      //       route: '/position-tasks',
      //     },
      //     {
      //       text: 'crm.tasks',
      //       route: '/tasks',
      //     },
      //   ],
      // },
      {
        icon: 'person_add_disabled',
        text: 'admin.name',
        model: false,
        guard: 'ADMIN',
        route: '/administration',
        children: [
          {
            text: 'admin.users',
            route: '/users',
          },
          // {
          //   text: 'admin.permissions',
          //   route: '/permissions',
          // },
          // {
          //   text: 'admin.userPermissions',
          //   route: '/user-permissions',
          // },
        ],
      },
    ],
  }),
  computed: {
    ...mapGetters('auth', [
      'isLogged',
      'userInfo',
    ]),
    year () {
      let year = new Date()
      return year.getFullYear()
    },
  },
  components: {
    Sidebar,
    Toolbar,
    AlertBox,
    Footnote,
    BackTop,
    Profile,
    Notification
  },
}
</script>
<style scoped>
.container {
  max-width: 100%;
}
.main-container {
  padding: 10px 0 0 0;
  background-color: white;
  /* background-color: #fafafa; */
}
.content {
  min-height: 100vh;
  overflow-x: auto;
  background-color: white;
  /* background-color: #fafafa; */
}
.main-card {
  background-color: white;
  /* background-color: #fafafa; */
}
.card-title {
  padding: 0;
}
.content-container {
  margin-bottom: 100px;
  padding: 0;
}
/* .v-data-table {
  background-color: #fafafa;
} */
</style>
